import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirmaService {

constructor(private http: HttpClient) { }


ara(search:any,page:any)
{
 return this.http.get<any[]>(`${environment.apiUrl}firmalar?search=${search}&page=${page}`);
}


firmamustahzar(id:any)
{
 return this.http.get<any[]>(`${environment.apiUrl}firmalar/${id}/mustahzarlar`);
}


}
